<template>
    <div>
    <filtered-search
        :search-filters="searchFilters"
        :search-route="searchRoute"
        :place-holder="placeHolder"
        :model="model"
    >
        <template slot="results" slot-scope="{ items }">
            <div>
                <li
                v-for="(facility, index) in items"
                :key="facility.id"
                :class="{
                    'border-t border-gray-200': index > 0
                }"
                >
                    <a
                    :href="facility.route"
                    class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                    >
                    <div class="flex items-center px-4 py-4 sm:px-6">
                        <div class="flex items-center flex-1 min-w-0">
                        <div
                            class="flex-1 min-w-0 md:px-4 md:grid md:grid-cols-4 md:gap-4"
                        >
                            <div class="col-span-3 space-y-1">
                            <div
                                class="flex space-x-2 text-sm font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 lg:text-md visited:text-indigo-800"
                            >
                                <span class="flex-shrink-0 truncate lg:flex-shrink" v-html="facility.name_edge_ngram">
                                </span>
                                <span
                                    v-if="facility.npi"
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide bg-gray-100 text-gray-800"
                                >
                                    NPI:
                                    {{ facility.npi }}
                                </span>
                                <span
                                    v-if="facility.firm_type"
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide bg-blue-100 text-blue-800"
                                >
                                    {{ facility.firm_type }}
                                </span>
                                <template v-if="facility.idns">
                                <span
                                    v-for="(idn) in facility.idns"
                                    :key="idn.id"
                                    class="text-sm font-normal text-gray-600 truncate"
                                >
                                    {{ idn.name }}
                                </span>
                                </template>
                            </div>
                            <div class="hidden md:block">
                                    <div v-if="facility.networks">
                                        <div
                                            v-for="(network) in facility.networks"
                                            :key="network.id"
                                            class="flex items-center text-sm font-medium leading-5 text-gray-900 truncate"
                                        >
                                            <span
                                                class="ml-1 font-normal text-gray-500 truncate"
                                            >
                                                {{ network.name }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="facility.city_state_edge_ngram"
                                    class="flex items-center text-sm leading-5 text-gray-500 sm:mt-0"
                                >
                                    <svg
                                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                        fill-rule="evenodd"
                                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                        clip-rule="evenodd"
                                        />
                                    </svg>
                                <span v-html="facility.city_state_edge_ngram"></span>
                                </div>
                            </div>
                            </div>
                            <div class="hidden md:block">
                            <div>
                                <div
                                    v-if="facility.gpos && facility.gpos.length"
                                    class="flex items-center text-sm font-medium leading-5 text-gray-900 truncate"
                                >
                                GPO:
                                <span
                                    v-for="(gpo) in facility.gpos"
                                    :key="gpo.id"
                                    class="ml-1 font-normal text-gray-500 truncate"
                                >
                                    {{ gpo.name }}
                                </span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div>
                        <svg
                            class="w-5 h-5 text-gray-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                            fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"
                            />
                        </svg>
                        </div>
                    </div>
                    </a>
                </li>
            </div>
        </template>
    </filtered-search>
    </div>
</template>
<script>
export default {
  props: {
    searchFilters: {
      type: [Array, Object],
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    placeHolder: {
        type: String,
        required: false,
        default: 'Search...'
    },
    modelName: {
        type: String,
        required: false,
    },
    model: {
        type: [Array, Object],
        required: true
    }
  },
  data: () => ({}),
};
</script>

